import React, { Component } from "react";
import { Table } from "antd";
import TableRecordByOrg from "./TableRecordByOrg";
import "../expenses.less";

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: this.props.dataSource,
      visible: false,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataSource: nextProps.dataSource,
    });
  }

  handleDrawer = org => {
    this.setState({
      org,
    });
    this.handleVisible(true);
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

 columns = () => {
    return [
      {
        title: "公司名称",
        dataIndex: "company",
        render: (text, record) => {
          return <a onClick={() => this.handleDrawer(record)}>{text}</a>;
        },
      },
      {
        title: "开票次数",
        dataIndex: "count",
      },
      {
        title: "开票总金额",
        dataIndex: "sum",
      },
      {
        title: "开票进行中",
        dataIndex: "doing",
        key: "doing",
      },
      {
        title: "开票已完成",
        dataIndex: "done",
        key: "done",
      },
    ];
  }

  render() {
    const {
      dataSource: { list, pagination },
      visible,
      org,
    } = this.state;
    return (
      <div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          rowKey="companyUuid"
        />
        {visible ? (
          <TableRecordByOrg org={org} handleVisible={this.handleVisible} />
        ) : null}
      </div>
    );
  }
}
export default Manage;



// WEBPACK FOOTER //
// ./src/components/finance/invoice/TableStaticOrg.js